import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

interface AddFileData {
  fileName: string | null;
  file: string;
}

@Component({
  selector: 'add-unit-file',
  templateUrl: './add-unit-file.component.html',
  styleUrls: ['./add-unit-file.component.scss']
})
export class AddUnitFileComponent {

    file = {
    fileLabel: null,
    name: 'رفع الملف',
    progress: false,
    progressVal: 0
  }

  addFileFormGroup = new FormGroup({
    fileName: new FormControl(null, Validators.required),
    file: new FormControl(null, Validators.required)
  });

  constructor(@Inject(MAT_DIALOG_DATA) public data: AddFileData, private dialogRef: MatDialogRef<AddUnitFileComponent>) { }

  handleFile(event: any) {
    if (event.files && event.files.length > 0) {
      this.addFileFormGroup.get('file')?.setValue(event.files[0]);
      this.file.fileLabel = event.files[0].name;
    }
  }

  deleteFile() {
    this.addFileFormGroup.get('file')?.setValue(null);
    this.file.fileLabel = null;
  }

  save() {
    if (this.addFileFormGroup.valid) {
      this.data = {
        fileName: this.addFileFormGroup.value.fileName ?? null,
        file: this.addFileFormGroup.value.file ?? ''
      };
      this.dialogRef.close(this.data);
    }
  }
}
